<template>
    <div class="t-container page">
        <div class="page-heading" role="heading">
            <h1 class="page-heading__header">
                Analytics
            </h1>
        </div>

        <section class="dashboard-content t-flex-col t-rounded-md t-p-4 t-bg-white t-mb-5 t-mt-10">
            <el-row type="flex" justify="center" style="margin-top: 10px">
                <el-col :lg="24" :xl="22">
                    <el-card>
                        <div slot="header" class="t-mb-4 t-font-bold">
                            <span>Capacity Analytics</span>
                        </div>
                        <el-tabs v-model="activeName">
                            <el-tab-pane label="Route Reports" name="1">
                                <journey-requests-table :user="user"></journey-requests-table>
                            </el-tab-pane>
                            <el-tab-pane label="Truck Reports" name="2">
                                <journey-requests-truck-table :user="user"></journey-requests-truck-table>
                            </el-tab-pane>
                            <el-tab-pane label="Manage My Places" name="3">
                                <places-table></places-table>
                            </el-tab-pane>
                        </el-tabs>
                    </el-card>
                </el-col>
            </el-row>
        </section>
    </div>
</template>

<script>
    import JourneyRequestsTable from '../../components/tables/JourneyRequestsCarrier';
    import JourneyRequestsTruckTable from '../../components/tables/JourneyRequestsTruckCarrier';
    import PlacesTable from '../../components/tables/PlacesCarrier';

    export default {
        // Do not forget this little guy
        name: 'Analytics',
        // share common functionality with component mixins
        mixins: [],
        // compose new components
        extends: {},
        // component properties/variables
        props: {
            user: {
                required: true,
                type: Object,
            }
        },
        // variables
        data() {
            return {
                activeName: '1',
            }
        },
        computed: {},
        // when component uses other components
        components: {
            JourneyRequestsTable,
            JourneyRequestsTruckTable,
            PlacesTable,
        },
        // methods
        watch: {},
        methods: {},
        // component Lifecycle hooks
        beforeCreate() {
        },
        mounted() {
        },
    };
</script>

<style scoped>

</style>